module.exports = __webpack_public_path__ + "img/swiper-left-icon.0c5f86be.png";